@if (
  (menuItems$ | async).length > 0 && {
    expanded: isExpanded$ | async,
    menuItems: menuItems$ | async,
    menuItemsSecondary: menuItemsSecondary$ | async,
  };
  as data
) {
  <div
    class="main-menu"
    [class.expanded]="data.expanded"
    [class.double]="data.menuItemsSecondary.length > 0"
  >
    @if (mainMenuCanToggle$ | async) {
      <div class="toggle" (click)="toggleSidebar()">
        <a
          ><fa-icon
            [icon]="!isRtl ? ['fas', 'arrow-right'] : ['fas', 'arrow-left']"
          ></fa-icon
        ></a>
      </div>
    }
    <div class="app-menu">
      <!-- Company Section -->
      @if (hasUser) {
        <div class="module" [class.border-bottom]="!data.expanded">
          <app-module-switch
            [showActiveInfo]="data.expanded"
          ></app-module-switch>
        </div>
      }
      <!-- Search Section -->
      @if (data.expanded) {
        <app-search-input
          (inputChanged)="onSearchChange($event)"
        ></app-search-input>
      }
      <!-- Back Button -->
      @if (hasBackButton) {
        <div class="back">
          <a (click)="back()">
            <span class="back-btn">
              <fa-icon [icon]="['fas', 'arrow-left']" size="1x"></fa-icon>
            </span>
            {{ "main-menu.button.back" | translate }}
          </a>
        </div>
      }
      <!-- Menu Section -->
      <div class="menus">
        <!-- Primary and Secondary Menu -->
        @for (
          menuItems of [data.menuItems, data.menuItemsSecondary];
          track menuItems;
          let i = $index
        ) {
          @if (menuItems.length > 0) {
            <ul
              class="menu-items"
              [class.filtered]="filtered"
              [class.second]="i > 0"
              [class.menu-items-small]="!data.expanded"
            >
              @for (menu of menuItems; track menu) {
                <li
                  [class.menu-item]="data.expanded"
                  [class.menu-item-small]="!data.expanded"
                  placement="right"
                >
                  <ng-container>
                    <ul class="submenu-items">
                      <div class="header-item" (click)="toggleMenuHeader(menu)">
                        <span>{{ menu.title }}</span>
                        <fa-icon
                          class="submenu-icon"
                          [icon]="
                            menu.expanded
                              ? ['fas', 'caret-up']
                              : ['fas', 'caret-down']
                          "
                        ></fa-icon>
                      </div>
                      <ng-container>
                        @for (submenu of menu.children; track submenu) {
                          <li
                            [class.should-hide]="!menu.expanded"
                            [class.search-match]="
                              searchString &&
                              submenu.title
                                ?.toLowerCase()
                                .includes(searchString.toLowerCase())
                            "
                            [class.d-none]="
                              searchString &&
                              !submenu?.title
                                .toLowerCase()
                                .includes(searchString.toLowerCase())
                            "
                            [routerLink]="submenu.link"
                            [routerLinkActive]="['active']"
                            [suiTooltip]="!data.expanded ? submenu.title : null"
                          >
                            <div class="submenu-item">
                              <fa-icon
                                class="submenu-icon"
                                [icon]="submenu.icon"
                                size="lg"
                                [routerLink]="submenu.link"
                              ></fa-icon>
                              <a
                                class="title"
                                [innerHTML]="
                                  submenu.title | highlight: searchString
                                "
                              >
                              </a>
                            </div>
                          </li>
                        }
                      </ng-container>
                    </ul>
                  </ng-container>
                </li>
              }
            </ul>
          }
        }
      </div>
    </div>
  </div>
}
